import { render, staticRenderFns } from "./CompanyWallet.vue?vue&type=template&id=13a6e592&"
import script from "./CompanyWallet.vue?vue&type=script&lang=js&"
export * from "./CompanyWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports